exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-container.card {\r\n  max-width: 375px;\r\n  padding: 40px 40px;\r\n}\r\n\r\n.card {\r\n  background-color: #F7F7F7;\r\n  padding: 20px 25px 30px;\r\n  margin: 0 auto 25px;\r\n  margin-top: 50px;\r\n  border-radius: 2px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/autoreport/autoreport.component.css
// module id = ./src/app/autoreport/autoreport.component.css
// module chunks = main